<sgt-multi-select
  #multiSelectRef
  [options]="selectorOptionsPeriodicidadeCompras"
  [settings]="settings"
  (isFirstOpened)="onFirstOpened($event)"
  (search)="onSelectionChange()"
>
</sgt-multi-select>
